import React from 'react';
import styled from 'styled-components';
import breakpoints from 'theme/breakpoints';

/*
 * Fundo e formas de vidro do painel da /entrar. As formas são recortes do
 * layout de referência, com o fundo do painel removido; ficam numa camada
 * própria atrás do painel porque o painel rola, e formas no fundo dele
 * aumentariam a área de rolagem.
 */
function SignInPanelDecor() {
    return (
        <Decor aria-hidden='true'>
            <TopBubbles src='/assets/images/signin-bubbles-top.png' alt='' />
            <BottomBubble src='/assets/images/signin-bubble-bottom.png' alt='' />
        </Decor>
    );
}

const Decor = styled.div`
    display: none;

    @media screen and (min-width: ${breakpoints.lg}) {
        display: block;
        position: absolute;
        top: 0;
        right: 0;
        width: 34.5625%;
        min-width: 460px;
        height: 100%;
        border-radius: 60px 0 0 60px;
        overflow: hidden;
        pointer-events: none;
        background:
            radial-gradient(circle 170px at 20px 210px, rgba(250, 228, 246, .55) 0%, rgba(250, 228, 246, 0) 100%),
            linear-gradient(180deg, #F8F6FD 0%, #F4F2FD 45%, #ECEBFD 100%);
    }
`;

const TopBubbles = styled.img`
    position: absolute;
    top: 0;
    right: 0;
    width: 200px;
    height: 172px;
`;

const BottomBubble = styled.img`
    position: absolute;
    right: 0;
    bottom: 0;
    width: 100px;
    height: 116px;
`;

export default SignInPanelDecor;
